import { motion } from 'framer-motion';
import type { PriceCadence } from '@/types/database';

interface BillingToggleProps {
  selected: PriceCadence;
  onSelect: (cadence: PriceCadence) => void;
  savingsPct: number;
  activeCadence?: PriceCadence | null;
}

export default function BillingToggle({
  selected,
  onSelect,
  savingsPct,
  activeCadence = null,
}: BillingToggleProps) {
  const options: Array<{ value: PriceCadence; label: string }> = [
    { value: 'monthly', label: 'Monthly' },
    { value: 'annual', label: 'Annual' },
  ];

  return (
    <div className="inline-flex items-center gap-1 rounded-full bg-border/40 p-1">
      {options.map((opt) => {
        const isSelected = selected === opt.value;
        const isCurrent = activeCadence === opt.value;
        return (
          <button
            key={opt.value}
            onClick={() => onSelect(opt.value)}
            className={`relative px-4 md:px-5 py-2 rounded-full font-sans text-sm font-medium transition-colors cursor-pointer ${
              isSelected
                ? 'text-text-primary'
                : 'text-text-muted hover:text-text-secondary'
            }`}
          >
            {isSelected && (
              <motion.span
                layoutId="billing-toggle-active"
                className="absolute inset-0 bg-card rounded-full shadow-sm"
                transition={{ type: 'spring', bounce: 0.15, duration: 0.4 }}
              />
            )}
            <span className="relative flex items-center gap-2">
              {opt.label}
              {opt.value === 'annual' && savingsPct > 0 && (
                <span
                  className={`font-sans text-[10px] font-semibold uppercase tracking-wide px-1.5 py-0.5 rounded-full ${
                    isSelected
                      ? 'bg-success/15 text-success-dark'
                      : 'bg-success/20 text-success-dark'
                  }`}
                >
                  Save {savingsPct}%
                </span>
              )}
              {isCurrent && (
                <span className="font-sans text-[10px] font-semibold uppercase tracking-wide text-primary">
                  · Current
                </span>
              )}
            </span>
          </button>
        );
      })}
    </div>
  );
}
